import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './enviroments/environment';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const ONESIGNAL_SDK_URL = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`No se pudo cargar el script: ${src}`));
    document.head.appendChild(s);
  });
}

/** Best-effort: si Brave Shields u otro bloqueador corta el CDN, la app igual arranca. */
async function initOneSignal(): Promise<void> {
  if (!environment.oneSignal.enabled) {
    return;
  }
  try {
    await loadScript(ONESIGNAL_SDK_URL);
    await import('./onesignal-init');
  } catch (err) {
    console.warn(
      '[OneSignal] SDK no disponible (bloqueado por el navegador, p. ej. Brave Shields). ' +
        'La aplicación continúa sin notificaciones push.',
      err,
    );
  }
}

async function start(): Promise<void> {
  await initOneSignal();
  await bootstrapApplication(App, appConfig);
}

start().catch((err) => console.error('[Vault] Error al arrancar la aplicación:', err));
